module.exports = __webpack_public_path__ + "img/1920_island_intro_img3.17ea3437.png";